import firebase from '@/api/firebase'

export default {
  data: () => ({
    experiences: [
      {
        title: 'Experiências 360',
        subtitle: 'A teoria aplicada no campo prático em <b>vídeos 360 graus</b>.',
        type: '360',
        src: require('@/assets/imgs/material-blue-800.jpg'),
        flex: 12
      },
      {
        title: 'Realidade Aumentada',
        subtitle: 'Elementos <b>3D interativos</b> e pedagógicos que podem ser explorados a qualquer momento.',
        type: '3d',
        src: require('@/assets/imgs/material-green-800.jpg'),
        flex: 6
      },
      {
        title: 'Simuladores',
        subtitle: '<b>Simulação de práticas</b> para que professores e estudantes possam explorar atividades imersivas.',
        type: 'labs',
        src: require('@/assets/imgs/material-yellow-800.jpg'),
        flex: 6
      },
    ],
    searchAll: 'searchall'
  }),
  created() {
    this.createUserPropertiesGoogleAnalytics()
  },
  methods: {
    routeToSearch(type) {
      let searchRoute = 'ContentSearch'

      this.$router.push({ name: searchRoute, query: { type: type } })
    },
    async getInstitution() {
      let params = {
        'userEmail': JSON.parse(localStorage.getItem('user')).email
      }
      let institution
      let data = firebase.getUserByEmail(params)
      await data.then((snapshot) => {
        snapshot.docs.forEach(user => {
          institution = user.data().institution
        })
      })
      return institution
    },
    async createUserPropertiesGoogleAnalytics(){
      let institution = await this.getInstitution()

      this.$gtag.event('visualize',{
        'event_category': 'User engagement',
        'event_label': 'Institution engagement',
        'institution': institution
      })

      this.$gtag.set('user_properties',{
        'institution': institution
      })
    }
  }
}
